export enum ActionTypes {
    LOGIN_WITH_PASSWORD = "loginWithPassword",
    LOG_OUT = "logout",
    CHECK_IS_LOGGED_IN = "checkIsLoggedIn"
}